import { BrowserRouter,  useLocation } from "react-router-dom";
import CollapsibleNavbar from "./Components/MenuItems/Navbar/Navbar";
import './css/global.css'
import Login from "./Components/Authentication/Login";
import SharedChatBot from "./Components/shared/SharedChatBot";
import { UserProvider } from "./utils/UserContext";
import { SocketProvider } from "./Components/Socket/SocketIo";
import { ProtectedRoute } from "./utils/ProtectedRoute";
import CrmChatbox from "./utils/CrmChatbox";


function AppRoutes() {
  const location = useLocation();

  if (location.pathname === '/login') {
    return <Login />;
  }

   if (location.pathname === '/crmChatbox') {
    return <CrmChatbox />;
  }

   return (
     <SocketProvider>
    <UserProvider>
      <ProtectedRoute>
      <CollapsibleNavbar />
      </ProtectedRoute>
    </UserProvider>
    </SocketProvider>
  );
}


function App() {
  return (
   
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
     
  );
}

export default App;
